module.exports = __webpack_public_path__ + "static/img/dia-del-nino-4.4404c49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/dia-del-nino-4.jpg
// module id = KJj0
// module chunks = 1